import { PlanSelect } from "@/design-system/primitives/PlanSelect";
import type { LabPurchaseType, LabInterval } from "@/types/labs";

export const labIntervalLabel = (months: LabInterval = 1) =>
  months === 1 ? "month" : months === 3 ? "quarter" : "6 months";
export function LabPurchaseOptions({
  purchaseType,
  interval,
  onChange,
  disabled = false,
}: {
  purchaseType: LabPurchaseType;
  interval: LabInterval;
  onChange: (type: LabPurchaseType, months: LabInterval) => void;
  disabled?: boolean;
}) {
  return (
    <fieldset disabled={disabled} className="min-w-0">
      <legend className="sr-only">Blood test purchase options</legend>
      <div
        className="flex border border-line-subtle"
        role="group"
        aria-label="Purchase type"
      >
        {(["subscription", "one_time"] as const).map((type) => (
          <button
            type="button"
            key={type}
            aria-pressed={purchaseType === type}
            onClick={() => onChange(type, interval)}
            className="flex-1 h-36 min-h-0 px-8 text-13 leading-120 bg-page aria-pressed:bg-ink aria-pressed:text-page disabled:opacity-60"
          >
            {type === "subscription" ? "Subscription" : "One-time"}
          </button>
        ))}
      </div>
      {purchaseType === "subscription" && (
        <label className="block mt-12 type-label-xs">
          <span className="block mb-6">Delivery frequency</span>
          <PlanSelect
            aria-label="Blood test frequency"
            value={interval}
            onChange={(event) =>
              onChange(purchaseType, Number(event.target.value) as LabInterval)
            }
          >
            {([1, 3, 6] as const).map((months) => (
              <option key={months} value={months}>
                1 test every {labIntervalLabel(months)}
              </option>
            ))}
          </PlanSelect>
        </label>
      )}
    </fieldset>
  );
}
